import 'bootstrap/dist/js/bootstrap'

export default function Footer(){
    return(
        <footer className="py-5 bg-dark">
            <div className="container"><p className="m-0 text-center text-white">کپی رایت &copy; فروشگاه ساز لینکت</p></div>
        </footer>
    )
}